import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2024 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { View, TsDataSource, LoadingContent, InlineEdit, themeListener, } from "../../index";
import { getBoard, saveTitle } from "../utils";
import { useEffect, useState } from "react";
import { Redirect, useParams } from "react-router-dom";
import { getUserFromLocalStorage } from "../../services/localStorage/localStorageService";
import { getCssVarValue } from "../../general/utils";
function Board(props) {
    const { dataUrl } = props;
    const ds = new TsDataSource();
    const { boardId, viewId } = useParams();
    const [user, setUser] = useState(null);
    const [boardData, setBoardData] = useState({});
    const [view, setView] = useState(viewId);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    themeListener(() => {
        try {
            const backing = document.getElementById("tol-app-background");
            backing.style.backgroundColor = getCssVarValue("--tol-bg-dark");
        }
        catch {
            return;
        }
    });
    useEffect(() => {
        const u = getUserFromLocalStorage();
        if (u)
            setUser(u);
    }, []);
    useEffect(() => {
        if (boardId && user) {
            getBoard(boardId, ds, user.id)
                .then((res) => {
                if (!view)
                    setView(res.views[0].id);
                setBoardData(res);
                setLoading(false);
            })
                .catch((e) => {
                setError(e);
                console.error(e);
            });
        }
    }, [boardId, user]);
    if (error !== "") {
        return _jsx(Redirect, { to: "/page-not-found" });
    }
    if (loading) {
        return _jsx(LoadingContent, { text: "Finding Board..." });
    }
    // returns the first view at the moment
    return (_jsxs("div", { className: "tol-board", children: [_jsx("div", { className: "tol-board-bar", children: _jsx(InlineEdit, { title: boardData.boardTitle, onSave: (newTitle) => {
                        if (newTitle !== boardData.boardTitle) {
                            saveTitle(newTitle, ds, boardId, "board");
                        }
                    } }) }), _jsx(View, { id: boardData.views[0].id, ds: ds, defaultFilter: boardData.views[0].filter, dataUrl: dataUrl })] }));
}
export default Board;
